<template>
	<layout-main>
		<v-container>
			<router-view v-if="$route.name !== 'Home'" />
			<nav-tiles v-else-if="tiles.length" :tiles="tiles" @click:tile="navigate" />
			<v-card v-else class="empty-card">
				<v-card-text v-text="emptyMsg" />
			</v-card>
		</v-container>

		<template v-if="showFooter" #footer>
			<layout-footer @click:tab="navigate" />
		</template>
	</layout-main>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import strings from "@/utils/strings";

export default {
	computed: {
		...mapGetters({
			tiles: "menu/getTiles",
		}),
		...mapState({
			communityId: state => "session.communityId",
		}),

		emptyMsg() {
			const client = this.$store.getters["config/inMobileApp"]
				? "mobile"
				: "desktop";
			return strings.home.empty[client];
		},

		// Show footer only if there's something to show.
		showFooter() {
			return this.$store.state.session.communityId;
		},
	},

	methods: {
		navigate(to) {
			if (to === "community") {
				return this.$router.push({
					name: "SelectContext",
					query: { force: true },
				});
			} else if (to === "room") {
				return this.$router.push({ name: "SelectContext" });
			} else if (to.includes("lock-manager")) {
				return this.$router.push({ path: to, query: { force: true } });
			} else {
				return this.$router.push({ path: to });
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.empty-card {
	margin: auto;
	max-width: 600px;
}
</style>
